module.exports = __webpack_public_path__ + "static/IvarText-Regular-56bc59b0f4b22ed919bbc31efc7b5d26.woff2";